import { StatusDefinition, allowedStatuses } from './Status'

export interface FundingCreatePayload {
    accountId: string
    currencyId: string
    amount: number
    // REFUND sends the selected simple payments' Wallex references
    reference: string | string[]
    fundingMethod: string
}

export interface FundingUpdatePayload {
    status: string
    fundingId: string
}

export interface FundingRetrieve {
    status: string
    id: string
    reference?: string
}

export default class Funding {
    static journey = ['pending', 'completed']

    static hints: Record<string, string> = {
        pending: 'Waiting for a decision',
        completed: 'Funds are credited to the account',
        failed: 'Rejected, nothing is credited',
    }

    // A funding can only change while it is pending
    static statuses(funding: { status: string }): StatusDefinition[] {
        const statuses: Array<StatusDefinition> = [
            {
                value: 'pending',
                description: 'Pending',
                available: [],
            },
            {
                value: 'completed',
                description: 'Completed',
                available: ['pending'],
            },
            {
                value: 'failed',
                description: 'Failed',
                available: ['pending'],
            },
        ]

        return allowedStatuses(statuses, funding.status)
    }
}
